import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { catchError, Observable, tap, throwError } from "rxjs";
import { ErrorHandlerService } from "../services/errorHandler.service";
import { StatusService } from "../services/status.service";

@Injectable()
export class NetworkStatusInterceptor implements HttpInterceptor {
  constructor(
    private errorHandlerService: ErrorHandlerService,
    private statusService: StatusService
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.url.indexOf("api.supervademecum.com.br") === -1 &&
      req.url.indexOf("localhost") === -1
    ) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      tap({
        next: (response: any) => {
          if (
            !this.statusService.getIsAppOnline() &&
            response?.status === 200
          ) {
            this.statusService.setAppOffline(false);
          }
        },
      }),
      catchError((error) => {
        if (
          this.statusService.getIsAppOnline() &&
          (error.status === 0 ||
            error.status === 503 ||
            error.status === 504 ||
            error.status === 524)
        ) {
          this.statusService.setAppOffline(true);
          this.errorHandlerService.handleError(error);
        }
        return throwError(() => error);
      })
    );
  }
}
